import { Button, Divider, InputLabel, TextField, IconButton } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { ApiRequest } from "GlobalFunctions";
import { useState } from "react";
import { useSnackbar } from 'notistack';
import { useSearchParams } from "react-router-dom";
import EmailChangeVerification from "./EmailChangeVerification";

export default function EmailChange(props: any) {
    const { setIsEditingEmail, setActiveAccountEditor, currentEmail: initialEmail } = props;
    const { enqueueSnackbar } = useSnackbar();
    const [searchParams] = useSearchParams();

    const [currentEmail, setCurrentEmail] = useState(initialEmail || '');
    const [newEmail, setNewEmail] = useState('');
    const [loadingButton, setLoadingButton] = useState(false);
    const [emailUpdated, setEmailUpdated] = useState(false);

    // Check if we're in verification mode
    const isVerificationMode = searchParams.get('code') && searchParams.get('type');

    const validateEmail = (email: string) => {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    };

    const handleSubmit = async () => {
        setLoadingButton(true);
        
        // Validate required fields
        if (!currentEmail || !newEmail) {
            enqueueSnackbar('All fields are required', { variant: 'error' });
            setLoadingButton(false);
            return;
        }

        // Validate email format
        if (!validateEmail(newEmail)) {
            enqueueSnackbar('Please enter a valid email address', { variant: 'error' });
            setLoadingButton(false);
            return;
        }

        // Prepare the request body
        const requestBody = {
            current_email: currentEmail,
            new_email: newEmail
        };
        
        await ApiRequest({
            url: '/stores/requestEmailChange',
            method: 'POST',
            body: requestBody,
            setResponse: (response: any) => {
                if(response.status === "success"){
                    setEmailUpdated(true);
                    // Clear form fields
                    setCurrentEmail('');
                    setNewEmail('');
                } else {
                    enqueueSnackbar(response.message, { variant: 'error' });
                }
                setLoadingButton(false);
            }
        });
    };

    // If we're in verification mode, show the verification component
    if (isVerificationMode) {
        return <EmailChangeVerification setLoading={setLoadingButton} />;
    }

    return (
        <div className='ModuleContainer alt_container'>
            <div className="ModuleHeader">
                <h1>Account</h1>
                <div className="ModuleActions">
                    
                </div>
            </div>
            <div className='ModuleContent'>
                <div className="account_section">
                    {!emailUpdated ? (
                        <>
                            <div className="section_header">
                                <h2>Edit Email</h2>
                                <div className="section_actions">
                                    <Button
                                        variant="text"
                                        onClick={() => setIsEditingEmail(false)}
                                        className="alt_btn"
                                    >
                                        Cancel
                                    </Button>

                                    <LoadingButton
                                        loading={loadingButton}
                                        onClick={handleSubmit}
                                        variant="contained"
                                        color="primary"
                                        className="alt_btn"
                                    >
                                        Save Changes
                                    </LoadingButton>
                                </div>
                            </div>

                            <div>
                                <form 
                                    className='password_change_form'
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        handleSubmit();
                                    }}>
                                    <div className="textfield_wrapper">
                                        <InputLabel className="login_label">Current Email</InputLabel>
                                        <TextField
                                            variant="outlined"
                                            value={currentEmail}
                                            onChange={(e) => setCurrentEmail(e.target.value)}
                                            type="email"
                                            fullWidth
                                            disabled={true}
                                            sx={{
                                                '& .MuiInputBase-root': {
                                                    backgroundColor: '#F5F5F5'
                                                }
                                            }}
                                        />
                                    </div>

                                    <div className="textfield_wrapper">
                                        <InputLabel className="login_label">New Email</InputLabel>
                                        <TextField
                                            variant="outlined"
                                            value={newEmail}
                                            onChange={(e) => setNewEmail(e.target.value)}
                                            type="email"
                                            fullWidth
                                            error={newEmail !== '' && !validateEmail(newEmail)}
                                            helperText={newEmail !== '' && !validateEmail(newEmail) ? 'Please enter a valid email address' : ''}
                                        />
                                    </div>
                                </form>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="section_header">
                                <h2>Edit Email</h2>
                                <div className="section_actions">
                                    <Button
                                        variant="contained"
                                        onClick={() => {
                                            setIsEditingEmail(false);
                                            setActiveAccountEditor(false);
                                        }}
                                        className="alt_btn"
                                    >
                                        Return To Account
                                    </Button>
                                </div>
                            </div>

                            <div className="change-email-toast-container">
                                Please check both your mailboxes to verify this change.
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}
